import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useLang } from "./LangContext";
import { scrollToId } from "../scroll";

export default function Navbar() {
  const { t, lang, setLang } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className={`nav ${scrolled ? "scrolled" : ""}`} data-testid="navbar">
      <div className="wrap nav-inner">
        <button className="nav-brand" data-testid="nav-brand-button" onClick={() => go("top")} aria-label="MDR Gaming House">
          <img src="/logo.png" alt="MDR Gaming House logo" />
          <span className="bt">
            MDR
            <small>GAMING HOUSE</small>
          </span>
        </button>

        <nav className="nav-links" aria-label="Ana gezinme">
          {t.nav.links.map((l) => (
            <button key={l.id} className="nav-link" data-testid={`nav-link-${l.id}`} onClick={() => go(l.id)}>
              {l.label}
            </button>
          ))}
        </nav>

        <div className="nav-actions">
          <div className="lang-switch" role="group" aria-label="Dil seçimi">
            <button
              className={`lang-btn ${lang === "tr" ? "on" : ""}`}
              data-testid="lang-toggle-tr"
              onClick={() => setLang("tr")}
            >
              TR
            </button>
            <button
              className={`lang-btn ${lang === "en" ? "on" : ""}`}
              data-testid="lang-toggle-en"
              onClick={() => setLang("en")}
            >
              EN
            </button>
          </div>
          <button className="nav-burger" data-testid="nav-burger" onClick={() => setOpen(!open)} aria-label="Menü">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            className="nav-mobile"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.32, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="wrap nav-mobile-inner">
              {t.nav.links.map((l) => (
                <button key={l.id} className="nav-link" data-testid={`nav-mobile-link-${l.id}`} onClick={() => go(l.id)}>
                  {l.label}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
